var _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 23,
    viewBox: "0 0 25 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24.1796,
    height: 22.7573,
    fill: "#858585"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_25_21)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.0781 7.52649C14.7148 7.65072 15.3 7.96213 15.7587 8.42086C16.2175 8.87958 16.5289 9.46476 16.6531 10.1015M14.0781 4.91888C15.401 5.06585 16.6346 5.65825 17.5763 6.59884C18.5181 7.53942 19.1121 8.77228 19.2607 10.095M18.6088 15.2972V17.2529C18.6095 17.4344 18.5723 17.6141 18.4996 17.7805C18.4269 17.9468 18.3202 18.0961 18.1864 18.2189C18.0526 18.3416 17.8947 18.4351 17.7227 18.4932C17.5507 18.5514 17.3685 18.573 17.1876 18.5567C15.1816 18.3387 13.2547 17.6532 11.5617 16.5553C9.98664 15.5544 8.65122 14.219 7.65034 12.6439C6.54861 10.9432 5.86298 9.00695 5.649 6.99193C5.63271 6.81166 5.65413 6.62997 5.71191 6.45843C5.76968 6.28689 5.86254 6.12926 5.98458 5.99558C6.10661 5.86189 6.25514 5.75508 6.42071 5.68195C6.58629 5.60881 6.76528 5.57096 6.94628 5.57079H8.90199C9.21836 5.56767 9.52507 5.6797 9.76495 5.886C10.0048 6.0923 10.1615 6.37878 10.2058 6.69206C10.2883 7.31792 10.4414 7.93245 10.6621 8.5239C10.7498 8.75723 10.7688 9.01081 10.7168 9.2546C10.6648 9.49839 10.544 9.72217 10.3688 9.89941L9.54085 10.7273C10.4689 12.3594 11.8202 13.7107 13.4523 14.6387L14.2802 13.8108C14.4574 13.6355 14.6812 13.5148 14.925 13.4628C15.1688 13.4108 15.4224 13.4298 15.6557 13.5175C16.2471 13.7382 16.8617 13.8912 17.4875 13.9738C17.8042 14.0185 18.0934 14.178 18.3001 14.422C18.5069 14.666 18.6167 14.9774 18.6088 15.2972Z",
    stroke: "#F3F3F3",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_25_21"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15.6456,
    height: 15.6456,
    fill: "white",
    transform: "translate(4.26697 4.26698)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.5c787ccacd61d5b067101a5753a58a83.svg";
export { ForwardRef as ReactComponent };